import React from 'react';

import { cn } from '@/lib/utils';

interface Props {
  testId: string;
  /** Radios that share a name form one group: arrow keys move between them. */
  name: string;
  label: string;
  selected: boolean;
  disabled?: boolean;
  /** Absent on a pill that only reports a state, such as "Mixed". */
  onSelect?: () => void;
}

/**
 * One option of a single-choice pill group, built on a visually hidden native
 * radio so the keyboard and screen-reader behaviour of a radiogroup come for
 * free: one Tab stop, arrow keys to move, Space to choose.
 */
export function ChoicePill({
  testId,
  name,
  label,
  selected,
  disabled = false,
  onSelect,
}: Props) {
  return (
    <label
      className={cn(
        'relative cursor-pointer rounded-full px-3 py-1.5 text-sm transition-colors has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-primary-500 has-[:focus-visible]:ring-offset-2 dark:has-[:focus-visible]:ring-offset-gray-900',
        selected
          ? 'bg-primary-500 font-semibold text-white'
          : 'bg-gray-100 font-medium text-gray-700 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600',
        disabled &&
          'cursor-default opacity-70 hover:bg-gray-100 dark:hover:bg-gray-700'
      )}
    >
      <input
        type="radio"
        name={name}
        data-testid={testId}
        checked={selected}
        disabled={disabled}
        onChange={() => onSelect?.()}
        className="sr-only"
      />
      {label}
    </label>
  );
}
